<template>
    <DModal
        :title="$t('users.create_modal_title')"
        :show="showModal"
        @close="$emit('close-modal')"
        @confirm="saveUser"
    >
        <DCard
            padding
        >
            <DFormRow
                :label="$t('users.field_name')"
                is-required
            >
                <DInput
                    v-model="form.name"
                    :placeholder="$t('users.field_name')"
                    add-input-classes="bg-light"
                    :is-valid="isValid('name')"
                    :feedback-invalid="errors.name"
                />
            </DFormRow>
            <DFormRow
                :label="$t('users.field_email')"
                is-required
            >
                <DInput
                    v-model="form.email"
                    :placeholder="$t('users.field_email')"
                    add-input-classes="bg-light"
                    :is-valid="isValid('email')"
                    :feedback-invalid="errors.email"
                />
            </DFormRow>
            <DFormRow
                :label="$t('users.field_password')"
                is-required
            >
                <DInput
                    v-model="form.password"
                    :placeholder="$t('users.field_password')"
                    add-input-classes="bg-light"
                    :is-valid="isValid('password')"
                    :feedback-invalid="errors.password"
                />
            </DFormRow>
            <DFormRow
                :label="$t('users.field_assign_role')"
                :is-required="true"
                :error="errors.role"
            >
                <DSelect
                    v-model="form.role"
                    :placeholder="$t('users.role_select_placeholder')"
                    :options="roles"
                    add-input-classes="bg-light"
                    :is-valid="errors.role ? false : null"
                />
            </DFormRow>
        </DCard>
        <template #buttons>
            <DButton
                :label="$t('common.ok')"
                color="primary"
                @click="saveUser"
            />
        </template>
    </DModal>
</template>

<script>
export default {
    name: 'CreateUserModal',
    props: {
        roles: {
            type: Array,
            default: () => { return [] }
        },
        errors: {
            type: Object,
            default: () => {
                return {}
            }
        },
        showModal: {
            type: Boolean,
            default: false
        },
        createForm: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    emits: ['save-user', 'close-modal'],
    data () {
        return {
            form: this.createForm
        }
    },
    methods: {
        saveUser () {
            this.$emit('save-user', this.form)
        },
        isValid (field) {
            if (typeof this.errors[field] !== 'undefined') {
                return false
            }

            if (this.form[field] === null) {
                return null
            }

            return null
        }
    }
}
</script>
